module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/e2d62d74ad94afd264cceb6ac6d9d9df.png";